import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../helper/custom-snackbar/custom-snackbar.component';
import Utils from '../util';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../helper/userpilot-reloader.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [
    './home.component.scss'
  ]
})
export class HomeComponent extends UserpilotReloader implements OnInit {
  onDestroyNotifier = new EventEmitter();
  trigger?: string;

  constructor(
    private router: Router,
    private snackService: MatSnackBar,
    public translationService: AnessaTranslationService
  ) {
    super();
  }

  ngOnInit() {

    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  canViewProjectInput() {
    return Utils.canViewProjectInput();
  }

  isInitialFormUser() {
    return Utils.isInitialFormUser();
  }

  isTranslator() {
    return Utils.isTranslator();
  }

  limitToScreeningProjects() {
    return Utils.limitToScreeningProjects();
  }

  isProjectLimitReached() {
    return Utils.isProjectLimitReached();
  }

  isScreeningProjectLimitReached() {
    return Utils.isScreeningProjectLimitReached();
  }

  open() {
    this.snackService.openFromComponent(CustomSnackbarComponent, {
      data: { message: '' },
      panelClass: ['anessa-snack-bar-container'],
    });
    this.router.navigateByUrl('/project/open');
  }

  newProject() {
    this.router.navigateByUrl('/project/new');
  }

  onNewInitialInformation() {
    this.router.navigateByUrl('/project-input');
  }
}
